const Form058EN = {
    stepName: {
        information: "Basic Information",
        partA: "Section A",
        partB: "Section B",
        certification: "Certification",
        confirm: "Confirmation",
    },
    labelStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
    ],
    notes: {
        items1: " (For supply teachers required to contribute to MPF, please provide supporting information of MPF if claim period is less than 60 days)",
        items2: 'For details, please refer to "Adjustment of Teacher Relief Grant in Aided IMC Schools after Packing of Classes". Aided secondary schools have to first offset (a) the fractional staff entitlement; (b) the Senior Secondary Curriculum Support Grant(SSCSG); and (c) the provision of supply teachers by the surplus teaching posts, in order of priority, during the toleration period under the Voluntary Optimisation of Class Structure Scheme as specified in paras. 4 and 5 of EDB Circular Memorandum No. 190/2010',
        tips1: "Teacher Professional Development Programmes on Special Education include:",
        "(a)": "(a) 30-hour Basic Course on Catering for Diverse Learning Needs <b><u>completed on or before 30 April 2021</u></b> (5 days)",
        "(b)": "(b) 102-hour Advanced Course on Catering for Diverse Learning Needs <b><u>completed on or before 30 April 2021</u></b> (17 days)",
        "(c)": "(c) 90/120-hour Thematic Courses on Supporting Students with Special Educational Needs <b><u>completed on or before 30 April 2021</u></b> (15/20 days)",
        "(d)": "(d) 72-hour Advanced Course on Catering for Diverse Learning Needs (12 days)",
        "(e)": "(e) 60/72-hour Thematic Courses on Supporting Students with Special Educational Needs (10/12 days)",
        "(f)": "(f) 240-hour Part I of Training Course for Special School Teachers(TCSST) (40 days) [not including Part II 6-month Practicum]",
        "(g)": "(g) 18-hour Elementary Course on Mental Health Promotion at Schools and Supporting Students with Mental Health Needs <b><u>completed on or before 30 March 2021</u></b> (3 days)",
        "(h)": "(h) 30-hour In-depth Course on Mental Health Promotion at Schools and Supporting Students with Mental Health Needs <b><u>completed on or before 30 March 2021</u></b> (5 days)",
        "(i)": "(i) 42-hour Training Course on Supporting Learning Needs of Students with Cortical Visual Impairment (6 days)",
        "(j)": "(j) 49-hour Training Course on Supporting Learning Needs of Students with Ocular Visual Impairment (7 days)",
        "(k)": "(k) 117-hour Professional Development Programme for the Special Educational Needs Coordinators(SENCO) (18 days)",
        tips2: "Granting of leave should follow EDB Circular No. 1/2006.",
        tips3: "Enter Staff Reference Number of teachers on leave.",
        tips4: "Enter the alphabet from the list of courses in Note 1.",
        tips5: "The number of working days should exclude Sunday, Saturday(short-week), public holidays, discretionary holidays or any days on which the teachers are not required to perform duties.",
        tips6: "Please refer to the relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers in aided schools.",
        tips7: "For supply period less than 60 calendar days yet the supply teacher is required to contribute to MPF, please provide supporting information.",
        terms1: "the emoluments have been paid to the supply teacher(s) and/or MPF scheme trustee(s) concerned. Relevant receipts are attached for your records;",
        terms2: "the claim(s) above do not fall within the ambits of the Teacher Relief Grant;",
        terms3Item1: "the school ",
        terms3Item3:
            " surplus teachers and the number of surplus teachers has been offset before employing any supply teachers",
        terms3End: "; and",
        terms4: "no duplicate claim has been made for government subventions on account of the same leave/vacancy set out above, such as the encashment of Additional Teaching Posts for English and the fractional staff entitlement for claiming Fractional Post Cash Grant.",
        terms5: "the school has verified the teacher registration documents of the supply teacher, and with the supply teacher’s consent, applied to the EDB for the release of the teacher registration information.",
        terms6: "My school will refund to the Government any over-payment of grant.",
        termsTips1: "Applicants should read carefully and agree",
        termsTips2: "Notes on private data",
        agreeTips:
            "I have read, understood and agreed to the above terms and conditions.",
    },
    serial: {
        tips: {
            num1: "(ⅰ)",
            num2: "(ⅱ)",
            num3: "(ⅲ)",
            num4: "(iv)",
            num5: "(v)",
        },
    },
    label: {
        basicOption: {
            note: "Note",
        },
        informationOption: {
            items: "Items: ",
            terms: "Terms and Conditions",
            title: "School Information",
            formType: "New/Revised Form",
            changePreClaim:
                "Unchange previous claim/Delete previous claim/Change previous claim",
            preClaimNum:
                "Please indicate the Application Number of Previous Claim Form",
            applicationNum: "Application Number",
            previousDate: "Copy of Previous Claim Dated",
            previousFormFile: "A Copy of Previous Claim",
            schoolName: "Name of School",
            schoolCode: "School Code",
            month: "Month",
            year: "Year",
        },
        partAOption: {
            title1: "A. Reimbursement of salaries and employer's contributions to Mandatory Provident Fund (MPF) schemes for eligible supply teachers arising from study leave of teachers attending teacher professional development programmes on special education",
            title2: " considered eligible by Education Bureau",
            teacherOnLeave: "Teacher on Leave",
            name: "Name",
            srn: "SRN",
            courseAttended: "Course Attended",
            post: "Post",
            leavePeriodForm: "Leave period From",
            leavePeriodTo: "Leave period To",
            supplyTearchName: "Name of Supply teacher",
            supplyPeriodFrom: "Supply period From",
            supplyPeriodTo: "Supply period To",
            workingDays: "No. of working days (a)",
            dailyRate: "Daily rate (b)",
            salaryAmount: "Salary amount (a)x(b)",
            mpfSubsidy: "MPF subsidy (c)",
            contractPeriodFrom: "Contract period From",
            contractPeriodTo: "Contract period To",
            leavePeriod: "leave period",
            contractPeriod: "contract period",
            amountUnit: "$",
            salaryAmountTotal: "Total of Salary Amount",
            mpfSubsidyTotal: "Total of MPF Subsidy",
            salaryAmountFile:
                "Attachment for the emoluments have been paid to the supply teacher(s) and/or MPF scheme trustee(s)",
            mpfSubsidyFile:
                "Attachment for MPF if claim period is less than 60 days",
        },
        partBOption: {
            title: "B. For temporary teachers appointed on monthly term, please submit appointment form available from EDB Internet",
            govUrl: "https://www.edb.gov.hk",
            itemStep1: "School Administration and Management",
            itemStep2: "Administration",
            itemStep3: "About School Staff",
            itemStep4: "Appointment Matters",
        },
        certificationOption: {
            title: "C. Certification",
            noteTitle: "I certify that – ",
            surplusTeachers: "Surplus Teachers",
            teacherNumber: "Number of Surplus Teachers",
            claimDate: "Claim Date",
            contactPerson: "Contact Person",
            telNo: "Tel No.",
            ssdo: "c.c. SSDO",
        },
    },
    select: {
        courseOption: {
            "(a)": "(a) 30-hour Basic Course on Catering for Diverse Learning Needs ",
            "(b)": "(b) 102-hour Advanced Course on Catering for Diverse Learning Needs ",
            "(c)": "(c) 90/120-hour Thematic Courses on Supporting Students with Special Educational Needs ",
            "(d)": "(d) 72-hour Advanced Course on Catering for Diverse Learning Needs (12 days)",
            "(e)": "(e) 60/72-hour Thematic Courses on Supporting Students with Special Educational Needs (10/12 days)",
            "(f)": "(f) 240-hour Part I of Training Course for Special School Teachers(TCSST) (40 days) [not including Part II 6-month Practicum]",
            "(g)": "(g) 18-hour Elementary Course on Mental Health Promotion at Schools and Supporting Students with Mental Health Needs ",
            "(h)": "(h) 30-hour In-depth Course on Mental Health Promotion at Schools and Supporting Students with Mental Health Needs ",
            "(i)": "(i) 42-hour Training Course on Supporting Learning Needs of Students with Cortical Visual Impairment (6 days)",
            "(j)": "(j) 49-hour Training Course on Supporting Learning Needs of Students with Ocular Visual Impairment (7 days)",
            "(k)": "(k) 117-hour Professional Development Programme for the Special Educational Needs Coordinators(SENCO) (18 days)",
        },
        newCourseOption: {
            "(a)": "(a) 72-hour Advanced Course on Catering for Diverse Learning Needs (12 days)",
            "(b)": "(b) 60/72-hour Thematic Courses on Supporting Students with Special Educational Needs (10/12 days)",
            "(c)": "(c) 240-hour Part I of Training Course for Special School Teachers (TCSST) (40 days) [not including Part II 6-month Practicum]",
            "(d)": "(d) 42-hour Training Course on Supporting Learning Needs of Students with Cortical Visual Impairment (6 days)",
            "(e)": "(e) 117-hour Professional Development Programme for the Special Educational Needs Coordinators (SENCO) (18 days)",
            "(f)": "(f) 18-hour Foundation Course for Special School Teachers (FCSST) (3 days)",
        },
        courseOptionBolder: {
            "(a)": "completed on or before 30 April 2021",
            "(b)": "completed on or before 30 April 2021",
            "(c)": "completed on or before 30 April 2021",
            "(g)": "completed on or before 30 March 2021",
            "(h)": "completed on or before 30 March 2021",
        },
        courseOptionAfter: {
            "(a)": " (5 days)",
            "(b)": " (17 days)",
            "(c)": " (15/20 days)",
            "(g)": " (3 days)",
            "(h)": " (5 days)",
        },
        courseWorkingDays: {
            "(a)": "5",
            "(b)": "17",
            "(c)": "20",
            "(d)": "12",
            "(e)": "12",
            "(f)": "40",
            "(g)": "3",
            "(h)": "5",
            "(i)": "6",
            "(j)": "7",
            "(k)": "18",
        },
        formTypeOption: {
            new: "New Form",
            revised: "Revised Form",
        },
        changePreClaimOption: {
            unchange: "Unchange Previous Claim",
            delete: "Delete Previous Claim",
            change: "Change Previous Claim",
        },
        surplusTeachersOption: {
            Yes: "has",
            No: "has no",
        },
        monthOption: {
            jan: "01",
            feb: "02",
            mar: "03",
            apr: "04",
            may: "05",
            jun: "06",
            jul: "07",
            aug: "08",
            sep: "09",
            oct: "10",
            nov: "11",
            dec: "12",
        },
    },
    errorMsg: {
        required: "This field is required",
        lengthMax: "This field must be at most {{max}} characters",
        maxDecimal: "This field must be at most 2 decimal places",
        maxOneDecimal: "This field must be at most 1 decimal places",
        validPrice: "Please input a valid price",
        numberMax: "This field must be at most {{number}} digits",
        numberUnit: "This field smallest unit must be 0.5",
        acdamicYear: "Please select the {{fildName}} within the school year",
        telMax: "Telephone number must be at most 12 digits",
        courseWorkingDays:
            "No. of working days cannot exceed the no. of days stated in Course Attended",
        supplyPeriodWorkingDays:
            "No. of working days cannot exceed the no. of days in supply period",
    },
};
export default Form058EN;
